import type { Account } from "bonusx-api-main-manager";
import { useEffect } from "react";
import { EXTERNAL_LOGIN_PATH, VERIFY_EMAIL_PATH } from "../../common/env";
import { useIsLogged } from "../../hooks/use-is-logged/use-is-logged";
import { useAccount } from "../../hooks/useAccount";
import { useNextURL } from "../../hooks/useNextURL";
import { getNextUrlFromParams } from "../../utils/getNextUrlFromParams";
import { isValidAppRoute } from "../../utils/is-valid-next-url-route";

interface InterceptNextURLProps {
  readonly children?: React.ReactNode;
  readonly nextUrl?: string | null;
}

export function InterceptNextURL({ children, nextUrl = getNextUrlFromParams() }: InterceptNextURLProps): JSX.Element {
  const isLogged = useIsLogged();
  const { accountData } = useAccount();
  const { set: storeNextURL, goToNextURL } = useNextURL();

  useEffect(
    function goToNextUrlWhenProfileIsCompletedOrStoreIt() {
      const nextUrlIsString = typeof nextUrl === "string";
      if (!nextUrlIsString) {
        return;
      }

      const nextUrlAvailable = isNextUrlAvailable(accountData) && isLogged;
      if (nextUrlAvailable) {
        console.debug("InterceptNextURL go to", nextUrl);
        return goToNextURL(nextUrl);
      }

      console.debug("InterceptNextURL store", nextUrl);

      if (isValidAppRoute(nextUrl)) {
        storeNextURL(nextUrl);
      }

      return;
    },
    [accountData]
  );

  return <>{children}</>;
}

function isNextUrlAvailable(accountData?: Account) {
  const accountIsVerified = accountData?.verified;
  const profileIsCompleted = accountData?.profileCompleted;
  const verifiedEmailLocation = isVerifyEmailLocation();
  const externalLoginLocation = isExteranlLoginLocation();

  const nextUrlAvailable = !verifiedEmailLocation && !externalLoginLocation && accountIsVerified && profileIsCompleted;

  return nextUrlAvailable;
}

function isVerifyEmailLocation() {
  return window.location.pathname.startsWith(VERIFY_EMAIL_PATH);
}

function isExteranlLoginLocation() {
  return window.location.pathname.startsWith(EXTERNAL_LOGIN_PATH);
}
